import { createFileRoute } from '@tanstack/react-router'
import { ProductsPage } from '@/features/products/products-page'
import { validateProductsSearch } from '@/features/products/search-state'

export const Route = createFileRoute('/_authenticated/products/')({
  staticData: { title: 'Products' },
  validateSearch: validateProductsSearch,
  component: ProductsRoute,
})

function ProductsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <ProductsPage
      search={search}
      onSearchChange={(nextSearch) => {
        void navigate({ search: nextSearch, replace: true })
      }}
    />
  )
}
